
// État initial
import {
	ADD_BOOKING_FAILURE,
	ADD_BOOKING_REQUEST,
	ADD_BOOKING_SUCCESS, ARRHES_BOOKING_FAILURE, ARRHES_BOOKING_REQUEST,
	ARRHES_BOOKING_SUCCESS,
	DELETE_BOOKING_FAILURE,
	DELETE_BOOKING_REQUEST,
	DELETE_BOOKING_SUCCESS,
	FETCH_BOOKINGS_FAILURE,
	FETCH_BOOKINGS_REQUEST,
	FETCH_BOOKINGS_SUCCESS,
	UPDATE_BOOKING_FAILURE,
	UPDATE_BOOKING_REQUEST,
	UPDATE_BOOKING_SUCCESS
} from "../actions/BookingAction";
import {formatDateToAPP} from "../../utils/tools";

const initialState = {
	data: [],
	loading: false,
	error: null
};

const reducer = (state = initialState, action) => {

	switch (action.type) {
		// FETCH
		case FETCH_BOOKINGS_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case FETCH_BOOKINGS_SUCCESS:
			const bookings = [...action.payload].map(booking => ({
				...booking,
				start_at: formatDateToAPP(booking.start_at),
				end_at: formatDateToAPP(booking.end_at),
				deposit_at: formatDateToAPP(booking.deposit_at)
			}));
			return {
				...state,
				loading: false,
				data: bookings
			};
		case FETCH_BOOKINGS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};


		// UPDATE
		case UPDATE_BOOKING_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case UPDATE_BOOKING_SUCCESS:
			return {
				...state,
				loading: false,
				data: state.data.map(booking =>
					booking.id === action.payload.id ? {
						...action.payload,
						start_at: formatDateToAPP(action.payload.start_at),
						end_at: formatDateToAPP(action.payload.end_at),
						deposit_at: formatDateToAPP(action.payload.deposit_at)
					} : booking
				)
			};
		case UPDATE_BOOKING_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};

		// ADD
		case ADD_BOOKING_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case ADD_BOOKING_SUCCESS:
			return {
				...state,
				loading: false,
				data: [...state.data, {
					...action.payload,
					start_at: formatDateToAPP(action.payload.start_at),
					end_at: formatDateToAPP(action.payload.end_at),
					deposit_at: formatDateToAPP(action.payload.deposit_at)
				}]
			};
		case ADD_BOOKING_FAILURE:
			return{
				...state,
				loading: false,
				error: action.payload
			};

		// DELETE
		case DELETE_BOOKING_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case DELETE_BOOKING_SUCCESS:
			//console.log('Avant suppression:', state.data);
			//console.log('ID à supprimer:', action.payload);
			const data = state.data.filter(booking => booking.id !== action.payload);
			//console.log('Après suppression:', newData);
			return {
				...state,
				loading: false,
				data: data
				//data: state.data.filter(booking => booking.id !== action.payload)
			};
		case DELETE_BOOKING_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};

		// ARRHES
		case ARRHES_BOOKING_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case ARRHES_BOOKING_SUCCESS:
			return {
				...state,
				loading: false,
				data: state.data.map(booking =>
					booking.id === action.payload.id ? {
						...action.payload,
						start_at: formatDateToAPP(action.payload.start_at),
						end_at: formatDateToAPP(action.payload.end_at),
						deposit_at: formatDateToAPP(action.payload.deposit_at)
					} : booking
				)
			};
		case ARRHES_BOOKING_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
		default:
			return state;
	}
}

export default reducer;